'use client'

import React, { useState } from 'react'
import { ChevronDown, ChevronUp } from 'lucide-react'

interface AwardCategoryProps {
  title: string
  children: React.ReactNode
}

const AwardCategory: React.FC<AwardCategoryProps> = ({ title, children }) => {
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <section className="mb-8 border border-gray-300 rounded-lg overflow-hidden">
      <button
        className="w-full text-left bg-blue-100 hover:bg-blue-200 transition-colors award-category-header"
        onClick={() => setIsExpanded(!isExpanded)}
        aria-expanded={isExpanded}
      >
        <h3 className="!m-0 !p-0">{title}</h3>
        {isExpanded ? <ChevronUp className="text-blue-600 flex-shrink-0" size={24} /> : <ChevronDown className="text-blue-600 flex-shrink-0" size={24} />}
      </button>
      {isExpanded && (
        <div className="p-4 space-y-6 bg-gray-50">
          {children}
        </div>
      )}
    </section>
  )
}

export default AwardCategory

